import { isEqualHex } from '@akropolis-web/primitives';

export function isWethAddress(address: string) {
  return isEqualHex(address, '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2');
}
